// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-278698fb] .v-input input:focus::-moz-placeholder {\n  color: #fff;\n}\n[data-v-278698fb] .v-input input:focus::placeholder {\n  color: #fff;\n}\n.v-btn.type-search .v-btn__content[data-v-278698fb] {\n  font-size: var(--font22);\n  font-weight: 700;\n}\n", ""]);
// Exports
module.exports = exports;
